export interface SortOption {
  key: string;
  label: string;
}

interface SortTabsProps {
  options: SortOption[];
  value: string;
  onChange: (key: string) => void;
}

export default function SortTabs({ options, value, onChange }: SortTabsProps) {
  return (
    <div className="flex items-center gap-1 bg-background-100 rounded-full p-1 w-fit">
      {options.map((opt) => (
        <button
          key={opt.key}
          type="button"
          onClick={() => onChange(opt.key)}
          className={`px-4 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
            value === opt.key
              ? "bg-background-50 text-primary-600 font-semibold"
              : "text-foreground-600 hover:text-foreground-900"
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}